export default {
  SET_INCENTIVES(state, payload) {
    state.incentives = payload.incentives.map((incentives) => ({ ...incentives }));
  },
  SET_LINKS(state, payload) {
    state.links = payload;
  },
};
